export function getOrder({ isFirstIcon, isRightToLeft, }) {
    if (isRightToLeft) {
        return !isFirstIcon ? 1 : 2;
    }
    return isFirstIcon ? 1 : 2;
}
